<template>
  <div>
    <Row class="margin-top-10">
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="data"
        ref="table"
        @on-selection-change="onSelectionChange"
      >
        <slot></slot>
      </Table>
    </Row>
    <Row class="margin-top-10" v-if="!noPagination">
      <Page
        :total="meta.total"
        :current="meta.current"
        show-total
        :page-size="meta.pageSize"
        @on-change="changePage"
      ></Page>
    </Row>
  </div>
</template>

<script>
import i18n from "../locales/index";

export default {
  // props: ['changePage', 'loading', 'data', 'columns', 'meta', 'onRowClick', 'onSelectionChange'],
  props: {
    changePage: {
      type: Function,
      default: () => {},
    },
    loading: Boolean,
    data: Array,
    columns: Array,
    meta: {
      type: Object,
      default: () => ({
        total: 0,
        current: 1,
        pageSize: 10,
      }),
    },
    onRowClick: {
      type: Function,
      default: () => {},
    },
    onSelectionChange: {
      type: Function,
      default: () => {},
    },
    noPagination: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.margin-top-10 {
  margin-top: 10px;
}
</style>
